var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 0.739258C16.6638 0.739258 21.2603 5.33573 21.2603 10.9992C21.2603 16.6627 16.6638 21.2592 11.0003 21.2592C5.33677 21.2592 0.740295 16.6627 0.740295 10.9992C0.740295 5.33573 5.33677 0.739258 11.0003 0.739258ZM6.8655 11.543L9.9435 14.621C10.0974 14.7749 10.2923 14.8467 10.4873 14.8467C10.6822 14.8467 10.8772 14.7749 11.0311 14.621C11.3286 14.3235 11.3286 13.831 11.0311 13.5335L9.26634 11.7687H14.5913C15.0119 11.7687 15.3608 11.4199 15.3608 10.9992C15.3608 10.5786 15.0119 10.2297 14.5913 10.2297H9.26634L11.0311 8.46502C11.3286 8.16748 11.3286 7.675 11.0311 7.37746C10.7335 7.07993 10.241 7.07993 9.9435 7.37746L6.8655 10.4555C6.56796 10.753 6.56796 11.2455 6.8655 11.543Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollLeftArrow);
export default __webpack_public_path__ + "static/media/scroll-left-arrow.1efa75335a7f1d1e64ad11a2dc6fa1f2.svg";
export { ForwardRef as ReactComponent };